export interface Holiday {
    id: string
    month: string
    dateRange: {
        from: string // YYYY-MM-DD format
        to: string // YYYY-MM-DD format
    }
    displayDate: string
    duration: string
    title: string
    subtitle: string
}

export interface HolidayCalendarConfig {
    [domain: string]: {
        [locale: string]: Holiday[]
    }
}

export const holidayCalendarConfig: HolidayCalendarConfig = {
    fsa: {
        en: [
            {
                id: 'mid-year-vacation',
                month: 'January',
                dateRange: { from: '2026-01-09', to: '2026-01-17' },
                displayDate: '9 - 17 Jan',
                duration: '9 days',
                title: 'Mid-year vacation',
                subtitle: 'School holidays'
            },
            {
                id: 'founding-day',
                month: 'February',
                dateRange: { from: '2026-02-22', to: '2026-02-22' },
                displayDate: '22 Feb',
                duration: 'One day',
                title: 'Founding Day',
                subtitle: 'National holiday'
            },
            {
                id: 'eid-al-fitr',
                month: 'March',
                dateRange: { from: '2026-03-06', to: '2026-03-28' },
                displayDate: '6 - 28 Mar',
                duration: '20 days',
                title: 'Eid al-Fitr',
                subtitle: 'Public holidays'
            },
            {
                id: 'saudi-flag-day',
                month: 'March',
                dateRange: { from: '2026-03-11', to: '2026-03-11' },
                displayDate: '11 Mar',
                duration: 'One day',
                title: 'Saudi Flag Day',
                subtitle: 'National observance'
            },
            {
                id: 'eid-al-adha',
                month: 'May',
                dateRange: { from: '2026-05-22', to: '2026-06-01' },
                displayDate: '22 May - 1 Jun',
                duration: '10 days',
                title: 'Eid al-Adha',
                subtitle: 'Public holidays'
            },
            {
                id: 'summer-holidays',
                month: 'June',
                dateRange: { from: '2026-06-25', to: '2026-08-25' },
                displayDate: '25 Jun - 25 Aug',
                duration: '2 months',
                title: 'Summer Holidays',
                subtitle: 'School holidays'
            }
        ],
        ar: [
            {
                id: 'mid-year-vacation',
                month: 'يناير',
                dateRange: { from: '2026-01-09', to: '2026-01-17' },
                displayDate: '9 - 17 يناير',
                duration: '9 أيام',
                title: 'إجازة منتصف العام',
                subtitle: 'إجازة مدرسية'
            },
            {
                id: 'founding-day',
                month: 'فبراير',
                dateRange: { from: '2026-02-22', to: '2026-02-22' },
                displayDate: '22 فبراير',
                duration: 'يوم واحد',
                title: 'يوم التأسيس',
                subtitle: 'عطلة وطنية'
            },
            {
                id: 'eid-al-fitr',
                month: 'مارس',
                dateRange: { from: '2026-03-06', to: '2026-03-28' },
                displayDate: '6 - 28 مارس',
                duration: '20 يومًا',
                title: 'عيد الفطر',
                subtitle: 'عطلة رسمية'
            },
            {
                id: 'saudi-flag-day',
                month: 'مارس',
                dateRange: { from: '2026-03-11', to: '2026-03-11' },
                displayDate: '11 مارس',
                duration: 'يوم واحد',
                title: 'يوم العلم السعودي',
                subtitle: 'مناسبة وطنية'
            },
            {
                id: 'eid-al-adha',
                month: 'مايو',
                dateRange: { from: '2026-05-22', to: '2026-06-01' },
                displayDate: '22 مايو - 1 يونيو',
                duration: '10 أيام',
                title: 'عيد الأضحى',
                subtitle: 'عطلة رسمية'
            },
            {
                id: 'summer-holidays',
                month: 'يونيو',
                dateRange: { from: '2026-06-25', to: '2026-08-25' },
                displayDate: '25 يونيو - 25 أغسطس',
                duration: 'شهران',
                title: 'إجازة الصيف',
                subtitle: 'إجازة مدرسية'
            }
        ]
    },
    fae: {
        en: [
            {
                id: 'new-years-day',
                month: 'January',
                dateRange: { from: '2026-01-01', to: '2026-01-01' },
                displayDate: '1 Jan',
                duration: 'One day',
                title: "New Year's Day",
                subtitle: 'Public holiday'
            },
            {
                id: 'eid-al-fitr',
                month: 'March',
                dateRange: { from: '2026-03-20', to: '2026-03-22' },
                displayDate: '20 - 22 Mar',
                duration: '3 days',
                title: 'Eid Al Fitr',
                subtitle: 'Public holiday'
            },
            {
                id: 'arafat-day',
                month: 'May',
                dateRange: { from: '2026-05-26', to: '2026-05-26' },
                displayDate: '26 May',
                duration: 'One day',
                title: 'Arafat Day',
                subtitle: 'Religious holiday'
            },
            {
                id: 'eid-al-adha',
                month: 'May',
                dateRange: { from: '2026-05-27', to: '2026-05-29' },
                displayDate: '27 - 29 May',
                duration: '3 days',
                title: 'Eid Al Adha',
                subtitle: 'Public holiday'
            },
            {
                id: 'islamic-new-year',
                month: 'June',
                dateRange: { from: '2026-06-15', to: '2026-06-15' },
                displayDate: '15 Jun',
                duration: 'One day',
                title: 'Islamic New Year',
                subtitle: 'Religious holiday'
            },
            {
                id: 'prophet-birthday',
                month: 'August',
                dateRange: { from: '2026-08-24', to: '2026-08-24' },
                displayDate: '24 Aug',
                duration: 'One day',
                title: "The Prophet Muhammad's Birthday (PBUH)",
                subtitle: 'Religious holiday'
            },
            {
                id: 'national-day',
                month: 'December',
                dateRange: { from: '2026-12-02', to: '2026-12-03' },
                displayDate: '2 - 3 Dec',
                duration: '2 days',
                title: 'National Day',
                subtitle: 'National holiday'
            }
        ],
        ar: [
            {
                id: 'new-years-day',
                month: 'يناير',
                dateRange: { from: '2026-01-01', to: '2026-01-01' },
                displayDate: '1 يناير',
                duration: 'يوم واحد',
                title: 'رأس السنة الميلادية',
                subtitle: 'عطلة رسمية'
            },
            {
                id: 'eid-al-fitr',
                month: 'مارس',
                dateRange: { from: '2026-03-20', to: '2026-03-22' },
                displayDate: '20 - 22 مارس',
                duration: '3 أيام',
                title: 'عيد الفطر',
                subtitle: 'عطلة رسمية'
            },
            {
                id: 'arafat-day',
                month: 'مايو',
                dateRange: { from: '2026-05-26', to: '2026-05-26' },
                displayDate: '26 مايو',
                duration: 'يوم واحد',
                title: 'يوم عرفة',
                subtitle: 'عطلة دينية'
            },
            {
                id: 'eid-al-adha',
                month: 'مايو',
                dateRange: { from: '2026-05-27', to: '2026-05-29' },
                displayDate: '27 - 29 مايو',
                duration: '3 أيام',
                title: 'عيد الأضحى',
                subtitle: 'عطلة رسمية'
            },
            {
                id: 'islamic-new-year',
                month: 'يونيو',
                dateRange: { from: '2026-06-15', to: '2026-06-15' },
                displayDate: '15 يونيو',
                duration: 'يوم واحد',
                title: 'رأس السنة الهجرية',
                subtitle: 'عطلة دينية'
            },
            {
                id: 'prophet-birthday',
                month: 'أغسطس',
                dateRange: { from: '2026-08-24', to: '2026-08-24' },
                displayDate: '24 أغسطس',
                duration: 'يوم واحد',
                title: 'المولد النبوي الشريف',
                subtitle: 'عطلة دينية'
            },
            {
                id: 'national-day',
                month: 'ديسمبر',
                dateRange: { from: '2026-12-02', to: '2026-12-03' },
                displayDate: '2 - 3 ديسمبر',
                duration: 'يومان',
                title: 'اليوم الوطني',
                subtitle: 'عطلة وطنية'
            }
        ]
    },
    egy: {
        en: [
            {
                id: 'coptic-christmas',
                month: 'January',
                dateRange: { from: '2026-01-07', to: '2026-01-07' },
                displayDate: '7 Jan',
                duration: 'One day',
                title: 'Coptic Christmas Day',
                subtitle: 'Public holiday'
            },
            {
                id: 'january-25-revolution',
                month: 'January',
                dateRange: { from: '2026-01-25', to: '2026-01-25' },
                displayDate: '25 Jan',
                duration: 'One day',
                title: 'January 25 Revolution & National Police Day',
                subtitle: 'National holiday'
            },
            {
                id: 'eid-al-fitr',
                month: 'March',
                dateRange: { from: '2026-03-20', to: '2026-03-22' },
                displayDate: '20 - 22 Mar',
                duration: 'Three days',
                title: 'Eid al-Fitr',
                subtitle: 'Public holiday'
            },
            {
                id: 'sham-el-nessim',
                month: 'April',
                dateRange: { from: '2026-04-13', to: '2026-04-13' },
                displayDate: '13 Apr',
                duration: 'One day',
                title: 'Sham El-Nessim (Spring Festival)',
                subtitle: 'Cultural holiday'
            },
            {
                id: 'sinai-liberation',
                month: 'April',
                dateRange: { from: '2026-04-25', to: '2026-04-25' },
                displayDate: '25 Apr',
                duration: 'One day',
                title: 'Sinai Liberation Day',
                subtitle: 'National holiday'
            },
            {
                id: 'labour-day',
                month: 'May',
                dateRange: { from: '2026-05-01', to: '2026-05-01' },
                displayDate: '1 May',
                duration: 'One day',
                title: 'Labour Day',
                subtitle: 'Public holiday'
            },
            {
                id: 'arafat-day',
                month: 'May',
                dateRange: { from: '2026-05-26', to: '2026-05-26' },
                displayDate: '26 May',
                duration: 'One day',
                title: 'Arafat Day',
                subtitle: 'Religious holiday'
            },
            {
                id: 'eid-al-adha',
                month: 'May',
                dateRange: { from: '2026-05-27', to: '2026-05-29' },
                displayDate: '27 - 29 May',
                duration: 'Three days',
                title: 'Eid al-Adha',
                subtitle: 'Public holiday'
            },
            {
                id: 'islamic-new-year',
                month: 'June',
                dateRange: { from: '2026-06-17', to: '2026-06-17' },
                displayDate: '17 Jun',
                duration: 'One day',
                title: 'Islamic New Year',
                subtitle: 'Religious holiday'
            },
            {
                id: 'june-30-revolution',
                month: 'June',
                dateRange: { from: '2026-06-30', to: '2026-06-30' },
                displayDate: '30 Jun',
                duration: 'One day',
                title: 'June 30 Revolution Day',
                subtitle: 'National holiday'
            },
            {
                id: 'july-23-revolution',
                month: 'July',
                dateRange: { from: '2026-07-23', to: '2026-07-23' },
                displayDate: '23 Jul',
                duration: 'One day',
                title: 'July 23 Revolution Day',
                subtitle: 'National holiday'
            },
            {
                id: 'prophet-birthday',
                month: 'August',
                dateRange: { from: '2026-08-26', to: '2026-08-26' },
                displayDate: '26 Aug',
                duration: 'One day',
                title: "Prophet Muhammad's Birthday",
                subtitle: 'Religious holiday'
            },
            {
                id: 'armed-forces-day',
                month: 'October',
                dateRange: { from: '2026-10-06', to: '2026-10-06' },
                displayDate: '6 Oct',
                duration: 'One day',
                title: 'Armed Forces Day',
                subtitle: 'National holiday'
            }
        ],
        ar: [
            {
                id: 'coptic-christmas',
                month: 'يناير',
                dateRange: { from: '2026-01-07', to: '2026-01-07' },
                displayDate: '7 يناير',
                duration: 'يوم واحد',
                title: 'عيد الميلاد المجيد',
                subtitle: 'عطلة رسمية'
            },
            {
                id: 'january-25-revolution',
                month: 'يناير',
                dateRange: { from: '2026-01-25', to: '2026-01-25' },
                displayDate: '25 يناير',
                duration: 'يوم واحد',
                title: 'ثورة 25 يناير وعيد الشرطة',
                subtitle: 'عطلة وطنية'
            },
            {
                id: 'eid-al-fitr',
                month: 'مارس',
                dateRange: { from: '2026-03-20', to: '2026-03-22' },
                displayDate: '20 - 22 مارس',
                duration: 'ثلاثة أيام',
                title: 'عيد الفطر',
                subtitle: 'عطلة رسمية'
            },
            {
                id: 'sham-el-nessim',
                month: 'أبريل',
                dateRange: { from: '2026-04-13', to: '2026-04-13' },
                displayDate: '13 أبريل',
                duration: 'يوم واحد',
                title: 'شم النسيم',
                subtitle: 'مناسبة شعبية'
            },
            {
                id: 'sinai-liberation',
                month: 'أبريل',
                dateRange: { from: '2026-04-25', to: '2026-04-25' },
                displayDate: '25 أبريل',
                duration: 'يوم واحد',
                title: 'عيد تحرير سيناء',
                subtitle: 'عطلة وطنية'
            },
            {
                id: 'labour-day',
                month: 'مايو',
                dateRange: { from: '2026-05-01', to: '2026-05-01' },
                displayDate: '1 مايو',
                duration: 'يوم واحد',
                title: 'عيد العمال',
                subtitle: 'عطلة رسمية'
            },
            {
                id: 'arafat-day',
                month: 'مايو',
                dateRange: { from: '2026-05-26', to: '2026-05-26' },
                displayDate: '26 مايو',
                duration: 'يوم واحد',
                title: 'يوم عرفة',
                subtitle: 'عطلة دينية'
            },
            {
                id: 'eid-al-adha',
                month: 'مايو',
                dateRange: { from: '2026-05-27', to: '2026-05-29' },
                displayDate: '27 - 29 مايو',
                duration: 'ثلاثة أيام',
                title: 'عيد الأضحى',
                subtitle: 'عطلة رسمية'
            },
            {
                id: 'islamic-new-year',
                month: 'يونيو',
                dateRange: { from: '2026-06-17', to: '2026-06-17' },
                displayDate: '17 يونيو',
                duration: 'يوم واحد',
                title: 'رأس السنة الهجرية',
                subtitle: 'عطلة دينية'
            },
            {
                id: 'june-30-revolution',
                month: 'يونيو',
                dateRange: { from: '2026-06-30', to: '2026-06-30' },
                displayDate: '30 يونيو',
                duration: 'يوم واحد',
                title: 'ثورة 30 يونيو',
                subtitle: 'عطلة وطنية'
            },
            {
                id: 'july-23-revolution',
                month: 'يوليو',
                dateRange: { from: '2026-07-23', to: '2026-07-23' },
                displayDate: '23 يوليو',
                duration: 'يوم واحد',
                title: 'ثورة 23 يوليو',
                subtitle: 'عطلة وطنية'
            },
            {
                id: 'prophet-birthday',
                month: 'أغسطس',
                dateRange: { from: '2026-08-26', to: '2026-08-26' },
                displayDate: '26 أغسطس',
                duration: 'يوم واحد',
                title: 'المولد النبوي الشريف',
                subtitle: 'عطلة دينية'
            },
            {
                id: 'armed-forces-day',
                month: 'أكتوبر',
                dateRange: { from: '2026-10-06', to: '2026-10-06' },
                displayDate: '6 أكتوبر',
                duration: 'يوم واحد',
                title: 'عيد القوات المسلحة',
                subtitle: 'عطلة وطنية'
            }
        ]
    }
}

